import * as ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import { CssBaseline } from '@mui/material';
import { RootThemeProvider } from './RootThemeProvider';
import Root from './root';
import './i18n';
import './index.scss';
import store from './store';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
	<HelmetProvider>
		<Provider store={store}>
			<RootThemeProvider>
				<CssBaseline />
				<Root />
			</RootThemeProvider>
		</Provider>
	</HelmetProvider>
);
